 
import SEO from '../../components/common/seo/SEO'
import CourseLandingPage from '../../components/Courses/CourseLandingPage/CourseLandingPage'
import TeamcenterPlmCourse from '../../data/cad_section/TeamcenterPlmCourse'

function TeamcenterPage() {
  return (
    <>
    <SEO
        title="Teamcenter PLM Customization Training | ITK, RAC, SOA & AWC Course | FeesWorth"

        description="Learn Siemens Teamcenter PLM customization and development with ITK, RAC, SOA, and Active Workspace. Gain practical experience in Teamcenter customization, integration, workflow, and PLM development with expert training at FeesWorth."

        keywords="Teamcenter Training, Teamcenter PLM Training, Teamcenter Customization Training, Teamcenter ITK Training, Teamcenter RAC Training, Teamcenter SOA Training, Teamcenter AWC Training, Teamcenter PLM Course, Teamcenter Customization Course, Teamcenter Development"

        canonical="https://feesworth.com/teamcenter-plm-customization-training-itk-rac-soa-awc"
      />
        <CourseLandingPage course={TeamcenterPlmCourse} />
    
    </>

  )
}

export default TeamcenterPage